<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template> 
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>NOVO TED TERCEIROS</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">

      <div class="p-6">

        <!-- PRICE -->
        <vs-input label="Valor" name="price" v-model.lazy="price" v-money="money" class="mt-5 w-full" />
		
		<vs-input label="Pin" name="pin" v-model="pin" class="mt-5 w-full" /><br>

        <!-- IMG -->
		<div class="vx-col w-full ">
			<statistics-card-line icon="DollarSignIcon" icon-right :statistic=price :statisticTitle=banco_name :chartData="analyticsData.siteTraffic"></statistics-card-line>
		</div><br>
		<div class="vx-col w-full">
			<vs-alert color="danger" icon="new_releases" active="true" title="Atenção">
				<p>Verifique atentamente a conta destinatária.</p>
			</vs-alert>
		</div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" @click="transferir">Transferir</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {VMoney} from 'v-money'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardOutLine.vue'
import analyticsData from '../card/analyticsData.js'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
	banco_name: '',
	banco_id: ''
  },
  data() {
    return {
	  analyticsData: analyticsData,
      name: '',
	  retorno: '',
	  pin: '',
	  encontrado: false,
      category: 'audio',
      order_status: 'pending',
      price: '',
		money: {
			decimal: ',',
			thousands: '.',
			prefix: 'R$ ',
			suffix: '',
			precision: 2,
			masked: false /* doesn't work with directive */
		},

      category_choices: [
        {text:'Audio',value:'audio'},
        {text:'Computers',value:'computers'},
        {text:'Fitness',value:'fitness'},
        {text:'Appliance',value:'appliance'}
      ],
      order_status_choices: [
        {text:'Pending',value:'pending'},
        {text:'Canceled',value:'canceled'},
        {text:'Delivered',value:'delivered'},
        {text:'On Hold',value:'on_hold'}
      ],
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar');
          this.initValues();
        }
      }
    }
  },
  methods: {
	number_format(number, decimals, decPoint, thousandsSep) {
		number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
		var n = !isFinite(+number) ? 0 : +number
		var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
		var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
		var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
		var s = ''
		var toFixedFix = function (n, prec) {
			var k = Math.pow(10, prec)
			return '' + (Math.round(n * k) / k).toFixed(prec)
		}
		// @todo: for IE parseFloat(0.55).toFixed(0) = 0;
		s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
		if (s[0].length > 3) {
			s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
		}
		if ((s[1] || '').length < prec) {
			s[1] = s[1] || ''
			s[1] += new Array(prec - s[1].length + 1).join('0')
		}
		return s.join(dec)
	},
  	transferir(name)
	{
		this.$vs.loading({
			type:'radius',
		})

		fetch(this.$store.state.API_URL + 'Financeiro/Transferencia/Ted/Outra', {
			method: 'POST',
			headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
			body: "token="+localStorage.getItem("token")+"&banco_id="+this.banco_id+"&valor="+this.price+"&pin="+this.pin
		})
		.then((response) => response.text())
		.then((responseData) => {
			var dados = JSON.parse(responseData);
			if(dados.done == true)
			{
				setTimeout( ()=> {
					this.$vs.loading.close();
					this.$parent.handler(JSON.parse(localStorage.getItem('userInfo')).Login, this.banco_name, dados.hash, dados.data_transacao, dados.valor, dados.taxa);
				}, 4000);

			}
			else
			{	
				setTimeout( ()=> {
					this.$vs.loading.close();
					this.$vs.notify({
						title: 'UzePay',
						text: dados.message,
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'warning'
					});

				}, 4000);
			}
			
		});
	},
  	getcliente(name)
	{
		fetch(this.$store.state.API_URL + 'Info/Login', {
			method: 'POST',
			headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
			body: "token="+localStorage.getItem("token")+"&id="+name
		})
		.then((response) => response.text())
		.then((responseData) => {
			var dados = JSON.parse(responseData);
			if(dados.success == true)
				this.retorno = dados.nome +" ("+name+")";
			else
				this.retorno =  "Não Encontrado";

		});
	},
    initValues() {
      this.name = '';
      this.category = 'audio';
      this.order_status = 'pending';
      this.price = '';
    }
  },
  components: {
    VuePerfectScrollbar,
	StatisticsCardLine,
  },
  directives: {money: VMoney}
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>
